import { html } from "lit";

export const youtubeIcon = (theme: string) => html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="${theme === "purple" ? "twf-fill-white" : "twf-fill-[#282828]"}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6668 4.08241C15.4824 3.39357 14.9411 2.85225 14.2522 2.66785C13.0036 2.33331 8 2.33331 8 2.33331C8 2.33331 2.99638 2.33331 1.74909 2.66785C1.06026 2.85225 0.518933 3.39357 0.334541 4.08241C0 5.32969 0 7.93358 0 7.93358C0 7.93358 0 10.5375 0.334541 11.7847C0.518933 12.4736 1.06026 13.0149 1.74909 13.1993C2.99638 13.5338 8 13.5338 8 13.5338C8 13.5338 13.0036 13.5338 14.2509 13.1993C14.9397 13.0149 15.4811 12.4736 15.6655 11.7847C16 10.5375 16 7.93358 16 7.93358C16 7.93358 16 5.32969 15.6655 4.08241H15.6668ZM6.39974 10.3333V5.53384L10.5565 7.93358L6.39974 10.3333Z"
    />
  </svg>
`;
